import { useEffect, type ReactNode } from 'react';
import { useSessionStore } from '@/entities/session';
import { Loader } from '@/shared/components';

interface SessionBootstrapProps {
  children: ReactNode;
}

export function SessionBootstrap({ children }: SessionBootstrapProps) {
  const status = useSessionStore(state => state.status);
  const bootstrap = useSessionStore(state => state.bootstrap);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  if (status !== 'ready') {
    return <Loader className="h-dvh" />;
  }

  return children;
}
